// extracted by mini-css-extract-plugin
export default {"list":"CarList_list__poNOw","empty":"CarList_empty__-RppH","emptyIcon":"CarList_emptyIcon__T6HCg","emptyTitle":"CarList_emptyTitle__kcHWS","emptyText":"CarList_emptyText__bPjcZ"};